import React from 'react';
import { createBrowserHistory } from 'history';
import { Router, Route, Switch, Redirect } from 'react-router-dom';

// core components
import Suite from '../../layouts/saas';
import Login from '../../layouts/Login';
import '../../assets/css/material-dashboard-react.css?v=1.6.0';


const App = () => {
  const history = createBrowserHistory();

  return (
    <Router history={history}>
      <Switch>
        <Route path="/saas" component={Suite} />
        <Route path="/rtl" component={Suite} />
        <Route path="/login" component={Login} />
        <Redirect from="/" to="/saas/asset-maintain/dashboard" />
      </Switch>
    </Router>
  );
};

export default App;
